"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgCalendarAddFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M5 4H4c-1.333 0-2 .668-2 2.004V8h11.354c.705-.622 1.632-1 2.646-1 .729 0 1.412.195 2 .535V6c0-1.333-.667-2-2-2h-1V2.941C15 2.314 14.667 2 14 2s-1 .314-1 .941V4H7.004V3c0-.667-.334-1-1.004-1-.67 0-1.002.333-1 1v1zM12.126 10H2v10c0 1.333.667 2 2 2h8.126A4.01 4.01 0 0112 21v-1h-1c-1.031 0-1.97-.39-2.68-1.03A1.54 1.54 0 018 19H7c-.667.001-1-.332-1-1 .001-.668.335-1.001 1.002-1h.124a4.007 4.007 0 010-2H7c-.667.001-1-.332-1-1 .001-.668.335-1.001 1.002-1H8c.117 0 .223.01.32.03C9.03 12.39 9.969 12 11 12h1v-1c0-.345.044-.68.126-1z' }),
    react_1.default.createElement("path", { d: 'M15 11a1 1 0 112 0v4h4a1 1 0 110 2h-4v4a1 1 0 11-2 0v-4h-4a1 1 0 110-2h4v-4z' }))); };
exports.default = SvgCalendarAddFilled;
//# sourceMappingURL=CalendarAddFilled.js.map